export default __webpack_public_path__ + "static/media/PC_US.5fe94418.svg";